import { CreateTemplateRequest } from '@domains/template/model/api/create-template-request.interface';
import { Category } from '@domains/category/model/api/category.interface';
import { TemplateKindType } from '@domains/template/model/api/template-kind-type.enum';
import { Website } from '@website-builder/model/domain/website/website';
import { ImageData } from '@domains/image/model/api/image-data.interface';

export class BuilderSamples {
  static pagePreview: ImageData = {
    imagePreview: 133,
    imagePreviewKey: 'Images/Public/22f47959c4e4943598bd6beedb5e74baa6c632bba9ab2c65518e8c1726fe3f42',
    imagePreviewUrl:
      'https://s3.us-west-2.amazonaws.com/dev.travelesolutions.website-builder/Images/Public/22f47959c4e4943598bd6beedb5e74baa6c632bba9ab2c65518e8c1726fe3f42?X-Amz-Expires=86400&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAR4GYKQZWNDKYMWVX%2F20260217%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20260217T120633Z&X-Amz-SignedHeaders=host&X-Amz-Signature=e0862bfd0cdf7aeef820886fd5ff63f24b5abb26fd619182ff1219022b7eb36f',
    imagePreviewThumbnailUrl:
      'https://s3.us-west-2.amazonaws.com/dev.travelesolutions.website-builder/Images/Public/Thumbnails/22f47959c4e4943598bd6beedb5e74baa6c632bba9ab2c65518e8c1726fe3f42?X-Amz-Expires=86400&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAR4GYKQZWNDKYMWVX%2F20260217%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20260217T120635Z&X-Amz-SignedHeaders=host&X-Amz-Signature=919787a28952262dfbdd2ad02224cd04ea747746ae55741b1e80a29b81d6e8ba',
    title: 'string',
    order: 0,
    id: 1,
    name: null,
    description: null,
    languageCode: null,
    disabled: false,
  };

  static Template(): CreateTemplateRequest {
    return {
      data: BuilderSamples.WebsiteDataDefaultTemplate(),
      kind: TemplateKindType.WEBSITE,
      imagePreview: 133,
      imagePreviewKey: 'Images/Public/22f47959c4e4943598bd6beedb5e74baa6c632bba9ab2c65518e8c1726fe3f42',
      imagePreviewUrl:
        'https://s3.us-west-2.amazonaws.com/dev.travelesolutions.website-builder/Images/Public/22f47959c4e4943598bd6beedb5e74baa6c632bba9ab2c65518e8c1726fe3f42?X-Amz-Expires=86400&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAR4GYKQZWNDKYMWVX%2F20260217%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20260217T120633Z&X-Amz-SignedHeaders=host&X-Amz-Signature=e0862bfd0cdf7aeef820886fd5ff63f24b5abb26fd619182ff1219022b7eb36f',
      imagePreviewThumbnailUrl:
        'https://s3.us-west-2.amazonaws.com/dev.travelesolutions.website-builder/Images/Public/Thumbnails/22f47959c4e4943598bd6beedb5e74baa6c632bba9ab2c65518e8c1726fe3f42?X-Amz-Expires=86400&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAR4GYKQZWNDKYMWVX%2F20260217%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20260217T120635Z&X-Amz-SignedHeaders=host&X-Amz-Signature=919787a28952262dfbdd2ad02224cd04ea747746ae55741b1e80a29b81d6e8ba',
      categories: [3, 18],
      pagePreviews: [this.pagePreview],
      contentImages: [0],
      name: 'Website',
      description: 'string',
      languageCode: null,
      disabled: false,
    };
  }

  static Category(): Category {
    return {
      id: -1,
      kind: 'Topic',
      name: 'All',
      description: 'All',
      creationDate: '',
      lastModified: null,
    };
  }

  static WebsiteDataDefaultTemplate(): string {
    const defaultTemplate = new Website();

    defaultTemplate.name = 'Mexico adventures';
    defaultTemplate.config.toTop.icon = 'mdi:arrow-up';
    defaultTemplate.config.toTop.style.decoration = 'tb-icon-square-fill';
    defaultTemplate.config.toTop.style.decorationColor = 'tb-icon-decoration-primary';
    defaultTemplate.config.toTop.style.color = 'tb-icon-white';
    defaultTemplate.config.toTop.style.hoverColor = 'tb-icon-hover-secondary';

    return JSON.stringify(defaultTemplate);
  }
}
